var mixins = {
    props: {
        name: {
            type: String,
            default: () => `${1 + Math.random()}`
        },
        rules: {
            type: Array,
            default: () => []
        },
        removeValidationPadding: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean
        }
    },
    data() {
        return {
            validationRule: ''
        }
    },
    watch: {
        rules_x: {
            handler(newRules) {
                if (newRules.any() && !this.name) {
                    throw 'name must be specified on any component with rules'
                }
                if (!this.name || !newRules.any()) {
                    this.validationRule = ''
                    return
                }
                this.validationRule = newRules
                    .map((rule, i) => {
                        var type = typeof rule
                        if (type !== 'string' && type !== 'function') {
                            throw `Invalid validation rule with type: ${type} on ${this.name}`
                        }

                        if (type === 'string') {
                            return rule
                        }

                        if (type == 'boolean') {
                            var isValid = rule
                            type = 'function'
                            rule = (v) => {
                                return isValid || 'Input is invalid'
                            }
                        }

                        var evaluate = rule
                        rule = `${this.name}_${i}`
                        this.$validator.extend(rule, {
                            getMessage: (field, params, msg) => {
                                return msg
                            },
                            validate: (value) => {
                                return new Promise((resolve) => {
                                    var result = evaluate(value)
                                    var valid = result === true
                                    resolve({
                                        valid,
                                        data: valid ? null : result ? result : 'Invalid input'
                                    })
                                })
                            }
                        })
                        return rule
                    })
                    .join('|')
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        rules_x() {
            if (this.required) {
                return [...this.rules, 'required']
            }
            return this.rules
        },
        hasValidation() {
            return !!this.validationRule
        },
        hasValidationErrors() {
            return this.errors.has(this.name)
        },
        errorText() {
            return this.errors.first(this.name) || null
        },
        label_text() {
            if (this.isRequired && this.label) {
                return `${this.label} *`
            }
            return this.label
        },
        placeholder_text() {
            var text = this.$attrs.placeholder || this.labelPlaceholder
            if (this.required && !this.label && text) {
                return `${text} *`
            }
            return text
        },
        isRequired() {
            return this.required || this.rules.indexOf('required') != -1
        }
    },
    mounted() {
        if (!this.name || !this.$validator) {
            return
        }
        if (this.$validator.fields.find({ name: this.name }) !== undefined) {
            return
        }

        this.$validator.attach({
            name: this.name,
            rules: this.validationRule,
            getter: () => this.value,
            value: this.value
        })

        this.$on(
            'input',
            function (value) {
                this.$validator.validate(this.name, value)
            }.bind(this)
        )
    }
}

export default mixins
